<template>
  <va-modal
    id="patients-result-type-modal"
    ref="patientsResultTypeModal"
    :value="isOpen"
    size="large"
    :showOkay="false"
    :cancelText="$t('modals.buttons.back')"
    @cancel="onCancel"
  >
    <div slot="header" class="modal-title d-flex justify--space-between">

      <span >{{ $t(titleMeasurementType) }} - {{ $t(titleResultType) }}</span>

      <va-popover
        placement="left"
        :message="$t('dashboard_new_evollu.download_excel')">
        <span class="icon i-cloud-download" @click.prevent="downloadExcel"></span>
      </va-popover>
    </div>



    <div class="table-container">
      <div v-if="isLoading" class="loading-overlay">
        <LoadingPlaceholder />
      </div>
      <v-server-table
        :columns="columns"
        :options="tableOptions"
        id="patientsTable"
        ref="patientsTable"
        name="patientsTable"
        @row-click="onPatientClicked"
      >

      <span slot="mobile" slot-scope="{row}">
        {{row.mobile || "N/A"}}
      </span>
        <span slot="email" slot-scope="{row}">
        {{row.email || "N/A"}}
      </span>
        <span slot="dateOfBirth" slot-scope="{row}">
        {{row.dateOfBirth ? moment(row.dateOfBirth).format("YYYY/MM/DD") : "N/A"}}
      </span>
        <span slot="facility" slot-scope="{row}">
        {{row.facilitiesEvollu ? row.facilitiesEvollu[0].name : "N/A"}}
      </span>
      </v-server-table>
    </div>


  </va-modal>
</template>

<script>
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder'
import TableView from "@/components/virtual_waiting_room/history/TableView.vue";
import {OneCareService} from "@/api/OneCareService";
export default {
  props: {
    resultTypeId: {
      type: Number,
      required: true
    },
    facilityId: {
      type: Number,
      required: false,
      default: null
    },
    titleMeasurementType: {
      type: String,
      required: true,
      default: "measurement"
    },
    titleResultType: {
      type: String,
      required: true,
      default: "resultType"
    },
    period: {
      type: Object,
      required: true,
    }
  },
  components: {
    TableView,
    LoadingPlaceholder
  },
  data: function () {
    return {
      isOpen: false,
      isLoading: false,
      hasMadeFirstRequest: false,
      isDownloadingExcel: false,
      isDownloadingExcelToast: null,
      querySearch: '',
      columns: ['name', 'mobile', 'email', 'dateOfBirth', 'facility'],
      tableOptions: {
        requestFunction: (data) => {
          return new Promise((resolve, reject) => {
            const page = data.page
            const pageSize = data.limit
            if (this.hasMadeFirstRequest) {
              this.isLoading = true
            }

            /*let params = {
              facilityId_evollu: this.facilityId,
              chart_result: this.resultTypeId,
              start: this.formatDate(this.start),
              end: this.formatDate(this.end),
              page: page,
              pageSize: pageSize
            } */

            let start = null
            let end = null

            const today = this.moment().endOf('day'); // Reference point: today, end of the current day

            switch (this.period.id) {
              case 0:
                // Last Day
                start = this.moment().subtract(1, 'days').startOf('day');
                end = today;
                break;

              case 1:
                // Last Week (last 7 days)
                start = this.moment().subtract(7, 'days').startOf('day');
                end = today;
                break;

              case 2:
                // Last Month (30 days back)
                start = this.moment().subtract(1, 'month').startOf('day');
                end = today;
                break;

              case 3:
                // Last 3 Months (90 days)
                start = this.moment().subtract(3, 'months').startOf('day');
                end = today;
                break;

              case 4:
                // Last 6 Months (180 days)
                start = this.moment().subtract(6, 'months').startOf('day');
                end = today;
                break;

              case 5:
                // Last Year (365 days)
                start = this.moment().subtract(1, 'year').startOf('day');
                end = today;
                break;

              default:
                start = end = null;
                break;
            }

            OneCareService.getPatientsFromResultTypeId(
              this.resultTypeId,
              this.facilityId,
              this.formatDate(start.format('YYYY/MM/DD HH:mm')),
              this.formatDate(end.format('YYYY/MM/DD HH:mm')),
              page,
              pageSize)
              .then(response => {
                if (response.page) {
                  this.$refs.patientsTable.$refs.pagination.Page = response.page
                }

                resolve({
                  data: response.objects,
                  count: response.totalItems,
                  page: response.page
                })
              })
              .catch(error => {
                reject(error)
              })
              .finally(() => {
                this.hasMadeFirstRequest = true
                this.isLoading = false
                }
              )
          })
        },
        sortable: [],
        filterable: true,
        skin: 'table table-striped table-hover is-fullwidth',
        headings: {
          name: this.$t('accounts.name'),
          mobile: this.$t('people.inputs.mobile-phone'),
          email: this.$t('accounts.email'),
          dateOfBirth: this.$t('clinical.people.birthday'),
          facility: this.$t('dashboard_new_evollu.titles.facility'),
        },
      },
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    formatDate(initial) {
      return initial.replaceAll("-", "/");
    },
    onCancel() {
      this.isOpen = false
      this.$emit('cancel')
    },
    onPatientClicked: function ({row}) {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('row-clicked', row)
      }, 500)
    },
    downloadExcel: async function () {
      if (!this.isDownloadingExcel) {
        this.isDownloadingExcel = true
        this.isDownloadingExcelToast = this.showToast(this.$t('dashboard_new_evollu.downloading_excel'), {
          ...this.$store.state.successToastOptions,
          icon: 'cloud-download',
          duration: null
        })
        let params = {}
        /*params.start = this.start.replace(/-/g,'/')
        params.end = this.end.replace(/-/g,'/')*/
        let start = null
        let end = null

        const today = this.moment().endOf('day'); // Reference point: today, end of the current day

        switch (this.period.id) {
          case 0:
            // Last Day
            start = this.moment().subtract(1, 'days').startOf('day');
            end = today;
            break;

          case 1:
            // Last Week (last 7 days)
            start = this.moment().subtract(7, 'days').startOf('day');
            end = today;
            break;

          case 2:
            // Last Month (30 days back)
            start = this.moment().subtract(1, 'month').startOf('day');
            end = today;
            break;

          case 3:
            // Last 3 Months (90 days)
            start = this.moment().subtract(3, 'months').startOf('day');
            end = today;
            break;

          case 4:
            // Last 6 Months (180 days)
            start = this.moment().subtract(6, 'months').startOf('day');
            end = today;
            break;

          case 5:
            // Last Year (365 days)
            start = this.moment().subtract(1, 'year').startOf('day');
            end = today;
            break;

          default:
            start = end = null;
            break;
        }
        params.start = this.formatDate(start.format('YYYY/MM/DD HH:mm')),
        params.end = this.formatDate(end.format('YYYY/MM/DD HH:mm')),
        params.chart_result = this.resultTypeId
        params.facilityId_evollu = this.facilityId

        try {
          const response = await OneCareService.downloadChartPatientsExcel(params)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'DashboardPatients.xls')
          document.body.appendChild(link)
          link.click()
          this.isDownloadingExcelToast.goAway(100)
        } catch (error) {
          console.error(error)
          this.isDownloadingExcelToast.goAway(100)
          setTimeout(() => {
            this.showToast(this.$t('dashboard_new_evollu.download_excel_generic_failure'), this.$store.state.errorToastOptions)
          }, 500)
        }
        this.isDownloadingExcelToast = null
        this.isDownloadingExcel = false
      }
    }
  }
}
</script>

<style lang="scss">
.table-container {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}


</style>
